/* eslint-disable react-hooks/exhaustive-deps */
import { FULL_DECK } from "../appData/deck";
import { SPREADS } from "../appData/spreads/spreads.data";
import { useEffect, useState } from "react";

import {
  getSpreadInitialState,
  drawCardsForSpread,
  replaySpreadInitialState,
} from "../services/spreads.service";
import { useEffectOnce } from "./useEffectOnce";
import { t } from "i18next";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const defaultSpread = SPREADS[1];

const useSpread = () => {
  const [spreadMetadata, setSpreadMetaData] =
    useState<ISpreadMetadata>(defaultSpread);
  const [deck] = useState<ITarotCard[]>(FULL_DECK);
  const [loading, setLoading] = useState<boolean>(true);
  const [spread, setSpread] = useState<ISpread>(getSpreadInitialState());

  useEffectOnce(() => {
    if (urlParams.has("query")) {
      replaySpread(urlParams.get("query"));
    } else {
      shuffleSpread();
    }
  });

  useEffect(() => {
    if (!loading) {
      console.log("spread changed");
      // setLoading(true);
      shuffleSpread();
    }
  }, [spreadMetadata]);

  const resetSpread = () => {
    window.history.pushState({}, document.title, "/");
    setSpreadMetaData(defaultSpread);
    setSpread(getSpreadInitialState());
    setLoading(true);
    shuffleSpread();
  };

  const replaySpread = (metaData: any) => {
    const parsedData: { sid: number; cids: IRedrawCardInfo[] } =
      JSON.parse(metaData);
    const { spreadMetadata, cards } = replaySpreadInitialState(
      parsedData.sid,
      parsedData.cids
    );
    setSpread(() => ({
      spreadMetadata,
      cards,
    }));
    setLoading(false);
  };

  const shuffleSpread = () => {
    setLoading(true);
    const cards = drawCardsForSpread(spreadMetadata, deck);
    setSpread(() => ({
      spreadMetadata,
      cards,
    }));
    setLoading(false);
  };

  const updateCard = (card: ISpreadCard, cardIndex: number) => {
    const newCards = [...spread.cards];
    newCards[cardIndex] = card;

    setSpread((prevState) => ({
      ...prevState,
      cards: newCards,
    }));
  };

  const changeSpread = (spreadId: number) => {
    setSpreadMetaData(
      SPREADS.find((spread) => spread.id === spreadId) || SPREADS[1]
    );
  };

  const copySpreadUrl = () => {
    const metaData = {
      sid: spread.spreadMetadata.id,
      cids: spread.cards.map(({ card, orientation, position }) => ({
        id: card.id,
        re: orientation.reversed,
        po: position.index,
      })),
    };

    const metaDataEncoded = encodeURIComponent(JSON.stringify(metaData));

    navigator.clipboard.writeText(
      `${window.location.href}?query=${metaDataEncoded}`
    );

    alert(
      t("Your spread copied succesfully!") || "Your spread copied succesfully!"
    );
  };

  return {
    loading,
    spread,
    updateCard,
    shuffleSpread,
    resetSpread,
    copySpreadUrl,
    urlParams,
    changeSpread,
  };
};

export { useSpread };
